angular
  .module('vppApp')
  .factory('CombineOffersService', CombineOffersService);
  CombineOffersService.$inject = ['$rootScope', 'GetOfferYears', 'vppConfig', 'BestAPRService'];

  function CombineOffersService($rootScope, GetOfferYears, vppConfig, BestAPRService) {
    var CombineOffersService = {};
    CombineOffersService.vehicles = [];


    CombineOffersService.combineOffers = function (currentMake, currentModel, currentDetails, programDetails) {
      var exlcudedProgramIds = vppConfig.exlcudedProgramIds;
      var minCash,
        amount;
      var aprValues = currentDetails.financeValues.details;
      var cashValues = currentDetails.cashValues.details;
      var vehicle = {};
      vehicle.make = currentMake;
      vehicle.model = currentModel;

      if (currentModel.indexOf('Base') > -1) {
        var b = currentModel.indexOf('Base');
        currentModel = currentModel.slice(0, b - 1);
      }

      if (currentDetails.cashValues.minimumDealCashValue) {
        minCash = parseInt(currentDetails.cashValues.minimumDealCashValue);
      }

      // combine cash values
      if (cashValues) {

        vehicle.cash = 0.0;
        vehicle.bonusCash = 0.0;
        vehicle.consumerCash = 0.0;
        vehicle.otherCashValues = 0.0;
        vehicle.minimumDealCashValue = minCash;

        if (currentDetails.financeValues.minimumDealCashValue) {
          vehicle.bonusCashApr = currentDetails.financeValues.minimumDealCashValue;
        }

        for (var key in cashValues) {
          var currCash = key;
          var thisKey;
          var subractCash;
          var programId = programDetails[key].id;
          amount = parseInt(cashValues[currCash].Cash);
          if (exlcudedProgramIds.indexOf(programId) > -1) {
            thisKey = currCash;
          }
          if (currCash === thisKey) {
            subractCash = parseInt(cashValues[currCash].Cash);
          } else {
            subractCash = 0;
          }

          switch (programDetails[key].programType) {
          case "Consumer Cash":
            vehicle.consumerCash += amount;
            break;
          case "Bonus Cash":
            if (exlcudedProgramIds.indexOf(programId) < 0) {
              vehicle.bonusCash += amount;
            }
            break;
          case "Dealer Cash":
            vehicle.consumerCash += amount;
            break;
          case "Employee Vehicle Allowance":
            vehicle.otherCashValues += amount;
          }
          amount = amount - subractCash;
          vehicle.cash += amount;

          // delete duplicate cash object from apr
          if (aprValues && aprValues[key]) {
            delete aprValues[key];
          }
        }

        if (minCash > vehicle.cash) {
          vehicle.cash = minCash;
        }
      }

      // get apr values, push multiples to display if more than one apr
      if (aprValues) {
        for (var i = 0; Object.keys(aprValues).length > i; i++) {
          var currAPR = Object.keys(aprValues)[i];
          amount = aprValues[currAPR];

          //if there are multiple aprs, create dummy object to push to prevent override
          if (Object.keys(aprValues).length > 1 && i !== 0) {

            var vehicleDup = {};
            vehicleDup.make = currentMake;
            vehicleDup.model = currentModel;
            vehicleDup.cash = vehicle.cash;
            vehicleDup.apr = amount;

            vehicleDup.bonusCash = vehicle.bonusCash;
            vehicleDup.consumerCash = vehicle.consumerCash;

            if (vehicleDup.cash !== 0 || vehicleDup.apr) {
              vehicleDup.bestApr = BestAPRService.getBestAprValues(vehicleDup.apr);
              CombineOffersService.vehicles.push(vehicleDup);
            }

          } else {
            vehicle.apr = amount;
            vehicle.bestApr = BestAPRService.getBestAprValues(vehicle.apr);
          }
        }
      }
      // check if empty in case empty items are added to the json
      if (vehicle.cash === 0 && !vehicle.apr) {
        return;
      }

      CombineOffersService.vehicles.push(vehicle);

    };
    return CombineOffersService;
  }